import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import useTags from "../../config/tags";

const lan = getLanguage();

const Index = ({ data, onChange, onClick, isBorder, item }) => {
  let inputElement = null;

  const { getTagName } = useTags();

  inputElement = (
    <>
      <div
        className={`d-flex flex-column justify-content-start`}
        onClick={onClick}
      >
        {/* <FormHeader
          onClick={onClick}
          data={{
            lan: lan,
            formHeader: data.header,
            size: "md-sm title",
          }}
        /> */}
        <div
          className={"lncmw_title"}
          dangerouslySetInnerHTML={{
            __html: data?.title,
          }}
        ></div>
        <div className={"lncmw__date"}>
          {moment(data.date).format("DD MMMM YYYY - HH:mm")}
        </div>
        <div className={"lncmw__tags d-flex flex-wrap"}>
          {data?.tags?.length > 0 &&
            data?.tags.map((tags, index) => (
              <Tag
                key={index}
                data={{
                  tagName: getTagName(tags)?.name,
                  type: "gray x",
                }}
              />
            ))}
          {/* <Tag
            data={{
              tagName: data.tagName,
              type: "gray x",
            }}
          />
          <Tag
            data={{
              tagName: "news_tag",
              type: "gray x",
            }}
          /> */}
        </div>
      </div>
    </>
  );

  return (
    <>
      <div
        className={`live-news-card-main-wrapper ${data.type} ${data.mainLayerStyles}`}
      >
        <>{inputElement}</>
      </div>
    </>
  );
};

export default Index;
